/* Example JSON
{
    "pk": 76,
    "id": 76,
    "user": 1,
    "read": null,
    "hide": false,
    "created_date": "2020-03-27T00:55:25.047294Z",
    "modified_date": "2020-03-27T00:55:25.047320Z",
    "button_selected": null,
    "notification_set": [
      {
        "pk": 1,
        "id": 1,
        "description": "Hello World",
        "buttons": [
          {
            "pk": 1,
            "id": 1,
            "button_text": "Ok",
            "style": "primary",
            "url": null,
            "value": "Ok"
          }
        ],
        "active_start_date": "2020-03-27T00:55:24.521633Z",
        "active_end_date": null
      }
    ]
  }
 */

import { Field, FIELD_TYPES, Model } from "../../vue-ocom/schema";

export default Model("user_notification", {
  verbose_name: "User Notification",
  verbose_name_plural: "User Notifications",
  fields: [
    Field("id", {
      label: "ID",
      primary_key: true,
      readonly: true,
      hide: false,
      field_type: FIELD_TYPES.AutoNumber,
    }),

    Field("user", {
      label: "User",
      primary_key: false,
      readonly: false,
      required: false,
      hide: false,
      field_type: FIELD_TYPES.ForeignKey,
      ref_field_type: "auth.User",
      ref_display_field: "username",
      default: () => {
        return null;
      },
    }),
    Field("read", {
      label: "Read",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Date,
      default: () => {
        return null;
      },
    }),
    Field("hide", {
      label: "Hide",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Boolean,
      default: () => {
        return false;
      },
    }),
    Field("created_date", {
      label: "Created Date",
      primary_key: false,
      readonly: true,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Date,
      default: () => {
        return null;
      },
    }),
    Field("modified_date", {
      label: "Modified Date",
      primary_key: false,
      readonly: true,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Date,
      default: () => {
        return null;
      },
    }),
    Field("button_selected", {
      label: "Button Selected",
      primary_key: false,
      readonly: false,
      hide: false,
      required: false,
      field_type: FIELD_TYPES.Number,
      default: () => {
        return null;
      },
    }),
  ],
});
